export default __webpack_public_path__ + "static/media/WINENOT.b60f2743.mp4";